@if (overdueDays) {
  <rt-badge
    rtTooltip
    [rtTooltipEnabled]="!!(hasTooltip() && overdueDays)"
    [rtTooltipTemplate]="tooltipTemplate"
    [rtTooltipMaxWidth]="156"
    [rtTooltipHasTextAlignCenter]="true"
    [rtTooltipHideDelay]="tooltipHideDelay()"
    rtTooltipPosition="below"
    color="overdue"
    text=" {{ 'app.overdue_candidates.badge' | translate: { days: overdueDays } }}"
  />
  <ng-template #tooltipTemplate>
    <span
      [innerHTML]="'app.overdue_candidates.x_badge_tooltip' | translate: { count: overdueDays }"
    ></span>
  </ng-template>
}
